import { HashRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import VSKAbout from "./pages/VSKAbout";
import VSKQuality from "./pages/VSKQuality";
import Contact from "./pages/Contact";

import VHome from "./pages/VHome";

import Bed from "./pages/Bed";
import Bath from "./pages/Bath";
import Banquet from "./pages/Banquet";
import Tote from "./pages/Tote";
import Fabrics from "./pages/Fabrics";
import ScrollToTop from "./components/ScrollToTop";
import "./loader.js";
import CertificationsPage from "./pages/Certifications";

function App() {
  return (
    <>
      <Router>
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<VHome />} />
          <Route path="/VSKAbout" element={<VSKAbout />} />

          <Route path="/VSKQuality" element={<VSKQuality />} />
          <Route path="/VHome" element={<VHome />} />
          <Route path="/Fabrics" element={<Fabrics />} />
          <Route path="/Contact" element={<Contact />} />

          <Route path="/Bed" element={<Bed />} />
          <Route path="/Bath" element={<Bath />} />
          <Route path="/Banquet" element={<Banquet />} />
          <Route path="/Tote" element={<Tote />} />
          <Route path="/Certifications" element={<CertificationsPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
